import { render, staticRenderFns } from "./infoListDialog.vue?vue&type=template&id=237f4f3c&scoped=true"
import script from "./infoListDialog.vue?vue&type=script&lang=js"
export * from "./infoListDialog.vue?vue&type=script&lang=js"
import style0 from "./infoListDialog.vue?vue&type=style&index=0&id=237f4f3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237f4f3c",
  null
  
)

export default component.exports